import { Injectable } from '@angular/core';
import { BaseSupportScriptService } from '../../base-support-script-service';

@Injectable({ providedIn: 'root' })
export class ZendeskService extends BaseSupportScriptService {
    public readonly scriptIdentifier: string = 'zendesk';
    private readonly zendeskHost: string = 'parcelpro.zendesk.com';

    public loadScript(): void {
        // Check if the script is already loaded
        const existingScript = document.head.querySelector(`script[data-script-identifier="${ this.scriptIdentifier }"]`);
        if (existingScript) {
            return;
        }

        // Create a new script element
        const script = document.createElement('script');
        script.text = `
window.zEmbed || function (e, t) {
    var n, o, d, i, s, a = [], r = document.createElement('iframe');
    window.zEmbed = function () {
        a.push(arguments);
    }, window.zE = window.zE || window.zEmbed, r.src = 'javascript:false', r.title = '', r.role = 'presentation', (r.frameElement || r).style.cssText = 'display: none', d = document.getElementsByTagName('script'), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;
    try {
        o = s;
    } catch (e) {
        n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);', o = s;
    }
    o.open()._l = function () {
        var e = this.createElement('script');
        n && (this.domain = n), e.id = 'js-iframe-async', e.src = 'https://assets.zendesk.com/embeddable_framework/main.js', this.t = +new Date, this.zendeskHost = "${ this.zendeskHost }", this.zEQueue = a, this.body.appendChild(e);
    }, o.write('<body onload="document._l();">'), o.close();
}();
    `;
        script.setAttribute('data-script-identifier', this.scriptIdentifier);
        document.head.appendChild(script);
    }

    public unloadScript(): void {
        super.unloadScript();

        const zE = (window as any).zE;
        if (zE) {
            zE.hide();
        }
    }
}
